import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['files', 'input'];

  elementId = 2;

  add(e) {
    e.preventDefault();
    const fileTag = document.createElement('div');
    fileTag.innerHTML =
      "<div class='file-group border border-coolgray-300 rounded-2xl py-2 px-4 mb-2'><input type='file' onchange='filecheck(this)' id='" +
      this.elementId +
      "'  name='attachFile'><a href='#' data-action='attached-file#delete' class='xi-close text-black'></a></div>";
    this.filesTarget.appendChild(fileTag);

    this.elementId += 1;
  }

  delete(e) {
    e.preventDefault();
    e.target.parentNode.remove();
  }

  toggleInput(e) {
    e.preventDefault();
    if (this.inputTarget.classList.contains('hidden')) {
      this.inputTarget.classList.remove('hidden');
    } else {
      this.inputTarget.classList.add('hidden');
    }
  }

  async deleteFile(e) {
    e.preventDefault();
    await this.fetchDelete(e.target.dataset.fileUrl);
    e.target.parentNode.remove();
  }

  async deleteAttachedFileInVote(e) {
    const currentGroupSlug = e.target.dataset.currentGroupSlug;
    const voteId = e.target.dataset.voteId;
    const voteContentId = e.target.dataset.voteContentId;
    const fileUrl = e.target.dataset.fileUrl;

    const response = await fetch(
      _spring['context_path'] + `/ajax/vote/${voteId}/vote-content/${voteContentId}/attached-file?file-url=${fileUrl}`,
      {
        method: 'DELETE',
        credentials: 'include',
        headers: Object.assign({}, _csrf, {
          'Content-Type': 'application/json',
        }),
      },
    );

    if (!response.ok) {
      return false;
    }
    e.target.parentNode.remove();
  }

  async fetchDelete(fileUrl) {
    const response = await fetch(`/ajax/attachment?url=${fileUrl}`, {
      method: 'DELETE',
      credentials: 'include',
      headers: Object.assign({}, _csrf, { 'Content-Type': 'application/json' }),
    });

    if (!response.ok) {
      return false;
    }
    return true;
  }

  addByid(e) {
    e.preventDefault();
    const fileTag = document.createElement('div');
    fileTag.innerHTML =
      "<div><input type='file' onchange='filecheck(this)' name='" +
      e.params.name +
      "'><a href='#' data-action='attached-file#delete' class='xi-close text-black'></a></div>";
    document.getElementById(e.params.id).appendChild(fileTag);
  }
}
